module.exports = __webpack_public_path__ + "static/media/edificio.5bb42549.svg";